// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox_checkbox__-37rR","mark":"checkbox_mark__drds8","disabled":"checkbox_disabled__4tujd"};